import { action, Action } from 'easy-peasy';

interface IImageEditorFile {
    /** 原始图片 */
    naturalImage: string;
    /** 原始图片大小 M */
    naturalFileSize: number;
    /** 图片名称 */
    naturalFileName: string;
    /** 图片后缀 */
    naturalFileSuffix: string;
    /** 原图信息 */
    originalSize?: string;
}

export enum ImageEditorModelType {
    naturalImage = 'naturalImage',
    naturalFileSize = 'naturalFileSize',
    naturalFileName = 'naturalFileName',
}

export interface IContrast {
    height?: number;
    width?: number;
    isShow?: boolean;
}

export interface IImageEditorModel extends IImageEditorFile {
    destroy: Action<IImageEditorModel>;
    /** 进入编辑入口 : 作图记录:record 新建画布 create 打开图片 open */
    enterType: string;
    setEnterType: Action<IImageEditorModel, string>;

    /** 超过最大提示压缩 10M */
    maxFileSize: number;
    /** 单边超过最大提示压缩 8000px*8000px */
    maxDimensions: number;

    setNaturalImage: Action<IImageEditorModel, string>;

    /** 创建图层 */
    create: Action<IImageEditorModel, IImageEditorFile>;

    /**
     * 对外聚合的 api 接口
     */
    /** 通过名称，获取对应属性值 */
    getStateByName: Action<
        IImageEditorModel,
        {
            payload: any;

            callback: Function;
        }
    >;

    /** 主图是否为透明 */
    isTransparent: boolean;
    /** 设置主图是否为透明 */
    setIsTransparent: Action<IImageEditorModel, boolean>;

    /** 图片编辑对比原图 */
    contrast: IContrast;
    setContrast: Action<IImageEditorModel, IContrast>;
}

export const imageEditorModel: IImageEditorModel = {
    destroy: action((state) => {
        state.naturalImage = '';
        state.naturalFileSize = 0;
        state.naturalFileName = '';
        state.originalSize = '';
        state.isTransparent = false;
        state.contrast = {
            width: 0,
            height: 0,
            isShow: false,
        };
    }),
    // TODO: 这个函数没有发现有在使用，可以删除
    getStateByName: action((state, { payload, callback }) => {
        switch (payload as ImageEditorModelType) {
            case ImageEditorModelType.naturalImage:
                callback(state.naturalImage);
                break;
            case ImageEditorModelType.naturalFileSize:
                callback(state.naturalFileSize);
                break;
            case ImageEditorModelType.naturalFileName:
                callback(state.naturalFileName);
                break;
            default:
                callback(null);
        }
    }),
    naturalImage: '',
    setNaturalImage: action((state, payload) => {
        state.naturalImage = payload;
    }),
    naturalFileSize: 0,
    naturalFileName: '',
    naturalFileSuffix: '',
    create: action((state, payload) => {
        state.naturalImage = payload.naturalImage;
        state.naturalFileSize = payload.naturalFileSize;
        state.naturalFileName = payload.naturalFileName;
        state.naturalFileSuffix = payload.naturalFileSuffix;
        state.originalSize = payload.originalSize;
    }),
    maxFileSize: 10 * 1024,
    maxDimensions: 8000,
    enterType: '',
    setEnterType: action((state, payload) => {
        state.enterType = payload;
    }),
    isTransparent: false,
    setIsTransparent: action((state, payload) => {
        state.isTransparent = payload;
    }),
    originalSize: '',
    contrast: {
        width: 0,
        height: 0,
        isShow: false,
    },
    setContrast: action((state, payload) => {
        state.contrast = { ...state.contrast, ...payload };
    }),
};
